





























import { Vue, Component, Prop } from 'vue-property-decorator';
import { BaseParagraph, ParagraphSize } from '../base-paragraph';

@Component({
  name: 'BaseInputBox',
  components: {
    BaseParagraph,
  },
  data: () => ({
    ParagraphSize,
  }),
})
export default class BaseInputBox extends Vue {
  @Prop() label: string;
  @Prop({ default: false }) success: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop({ default: '' }) errorMessage: string;
  @Prop({ default: false }) error: boolean;
  @Prop({ default: 0 }) prefixWidth: number;
  @Prop({ default: false }) active: boolean;
  @Prop() disabled: boolean;
  @Prop() forId: string;
  @Prop() dataExternal: string;

  get labelTransform(): string {
    if (this.active) {
      return `translate(0,0)`;
    }
    return `translate(${this.prefixWidth}px, 0)`;
  }
}
